import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraHomeRoute: InvariantJiraRoute = {
	name: 'your-work',
	path: '/jira/your-work',
};
